<template>
    <form-row title="Is a power of attorney needed for this closing?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center justify-between">
            <input-radio-boolean
                name="power_of_attorney_is_needed"
                v-model="power_of_attorney_is_needed"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <div v-if="power_of_attorney_is_needed"
                class="flex flex-1 justify-start sm:justify-end items-center pt-4 sm:pt-0"
            >
                <input-checkbox
                    name="power_of_attorney_is_needed_for_buyer"
                    label="For Buyer"
                    class="sm:w-1/3 py-0"
                    :value="attorney.power_of_attorney_is_needed_for_buyer"
                    :read_only="read_only"
                />

                <input-checkbox
                    v-if="power_of_attorney_is_needed"
                    name="power_of_attorney_is_needed_for_seller"
                    label="For Seller"
                    class="sm:w-1/3 py-0"
                    :value="attorney.power_of_attorney_is_needed_for_seller"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
    },

    data() {
        return {
            power_of_attorney_is_needed: this.attorney.power_of_attorney_is_needed,
        }
    },

    watch: {
        power_of_attorney_is_needed(val, oldVal) {
            this.$emit('updated', val);
        },
    },
}
</script>
